import { Settings } from 'core/hooks/settings/useSettings'
import { docCookies } from 'utils/docCookies'

export const isDev =
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'test' ||
  window.location.host.includes('localhost')
export const isStage = import.meta.env.VITE_APP_API_BASE_URL.includes('stage')
export const isPR = import.meta.env.VITE_APP_API_BASE_URL.includes('pr-')
export const isSalesDemoPrEnv = import.meta.env.VITE_APP_API_BASE_URL.includes(
  'api.pr-3513.deverlance.net'
)
export const isSalesDemoEnv =
  import.meta.env.VITE_APP_API_BASE_URL.includes(
    'api.local.everlance.localhost'
  ) || isSalesDemoPrEnv
export const isProd = import.meta.env.VITE_APP_API_BASE_URL.includes(
  'api.everlance.com'
)
export const isTesting = isDev || isStage || isPR

export const isMotusEnv =
  window.location.host ===
  new URL(import.meta.env.VITE_APP_PURPLE_DASHBOARD_URL).host //Todo: change to motus.com when in prod or testing

export const FONT_FAMILY = `${isMotusEnv ? 'Golos Text' : 'Avenir Next'}`

/**
 * @description Default global state (termed settings)
 */
const defaultSettings: Settings = {
  //TODO: refactor structure
  featureFlags: {
    ENABLE_EVERLANCE_PAYMENTS: isTesting && !isSalesDemoPrEnv,
    ENABLE_ONBOARDING_M3: isTesting && !isSalesDemoPrEnv,
    ENABLE_NEXT_PROGRAM: false,
    ENABLE_PAYMENTS_M3: isTesting && !isSalesDemoPrEnv,
    ENABLE_OUTLIERS_2: true,
    ENABLE_B2C_2: true,
    ENABLE_TAAP2: true,
    ENABLE_OLD_LOOMS: isTesting && !isSalesDemoPrEnv,
    ENABLE_CATALOG: false,
    // Motus feature flags
    ENABLE_DRIVER_EXPERIENCE: isMotusEnv,
    // Green app feature flags
    ENABLE_GREEN_APP: false
  },
  tripDetail: {
    tokenId: '',
    view: 'personal',
    props: {}
  },
  pollingJobs: {
    memberBulkInviteJobId: '',
    memberBatchInviteJobId: '',
    memberBulkUpdateJobId: '',
    memberExportJobId: '',
    payPeriodActionJobId: '',
    payPeriodDownloadJobId: '',
    reportBulkUpdateJobId: '',
    fundingRequestJobId: '',
    downloadSummaryJobId: '',
    importTeamPlacesJobId: '',
    mergeGroupIntegrationId: '',
    downloadMergeManagersJobId: '',
    memberBatchDeleteInviteJobId: '',
    mergePreviewEmployeedJobId: '',
    resetDemoAccountJobId: '',
    reportsActionJobId: '',
    taxReportJobId: ''
  },
  transactionDetail: {
    tokenId: '',
    view: 'personal',
    props: {}
  },
  inDrawerReport: {
    view: 'report',
    activeId: ''
  },
  memberInDrawerView: {
    view: 'main',
    activeId: '',
    prevReportId: null
  },
  mfa: {
    action: null,
    accountId: undefined,
    customerToken: undefined,
    onSuccess: null,
    onClose: null,
    onBack: null,
    continueButtonText: 'Continue',
    language:
      'https://ui.s.unit.sh/resources/2796/languages/113ec906-8c97-424c-b1b0-4803f79a06a3.json', // 13895
    themes: [
      'https://ui.s.unit.sh/resources/2796/themes/2a95c62d-dc5f-4408-a940-58446508d43e.json', // 10530
      'https://ui.s.unit.sh/resources/2796/themes/6b182443-dc8d-4732-a386-3fb0a2c8e9c9.json' // 10535
    ]
  },
  addToReportView: {
    view: 'main',
    activeId: ''
  },
  showWelcomeModal: false,
  inAppView: false,
  reimbursementTabParams: {
    pay_periods: '',
    reports: '',
    fixed: '',
    variable: ''
  },
  tooltipTutorial: {
    sideNavStep: 'account-switcher'
  },
  selectedRemoteFields: [],
  ratingModal: {
    active: false,
    trigger: ''
  },
  fundingModal: {
    show: false,
    showSuccessModal: false
  },
  auth: {
    isAuthenticated: !!localStorage.getItem('user-token-id'),
    isAuthLoading: true,
    userTokenID: localStorage.getItem('user-token-id'),
    accessToken: docCookies.getItem('motus_access_token'),
    refreshToken: docCookies.getItem('motus_refresh_token')
  },
  classifyLocationModal: {
    tripId: '',
    place: null,
    classification: null
  }
}

export { defaultSettings }
